module.exports = __webpack_public_path__ + "img/NoPalettes.33dcf34e.png";